module.exports = __webpack_public_path__ + "img/ai_pack.36b13dbe.png";